module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r1r4n8n-24e7e5e6be5ca949b552267c27605b8e.svg";